import { render, staticRenderFns } from "./SuspendedEmployeesTable.vue?vue&type=template&id=7ff9a11e&scoped=true&"
import script from "./SuspendedEmployeesTable.vue?vue&type=script&lang=js&"
export * from "./SuspendedEmployeesTable.vue?vue&type=script&lang=js&"
import style0 from "./SuspendedEmployeesTable.vue?vue&type=style&index=0&id=7ff9a11e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff9a11e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VAlert,VBtn,VDataTable,VIcon,VRow,VSpacer,VTextField,VToolbar,VToolbarTitle})
